import { useCallback, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { getConfig } from "./config";
import { APP_URL } from "../../API/apiConfig";
import {
  useLoggedInUserState,
  useLoggedInUserUpdater,
} from "../../context/UserContext";
// const _ = require('lodash');
import { isEqual } from "lodash";

export const useFetch = (url) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { apiOrigin = APP_URL } = getConfig();
  const setLoggedInUser = useLoggedInUserUpdater();
  const loggedInUser = useLoggedInUserState();
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  // console.log('uf', loggedInUser)
  const refetch = useCallback(async () => {
    // console.log("refetching");
    try {
      const token = await getAccessTokenSilently();
      // console.log(token);

      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const body = {
        userid: user.sub,
      };

      await axios
        .post(`${apiOrigin}/api/pos/auth0user`, body, config)
        .then((response) => {
          // console.log("fe res useFetch", response);
          if (!isEqual(loggedInUser, response.data)) {
            // console.log("not equal");
            setLoggedInUser(response.data);
          } else {
            // console.log("equal");
          }
        })
        .catch((error) => {
          console.log("fe err useFetch", error);
        });
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [getAccessTokenSilently]);

  useEffect(() => {
    refetch();
    // console.log("fetch");
  }, [refetch]);

  return {
    error,
    loading,
    // loggedInUser,
    refetch,
    isAuthenticated,
  };
};
